import { Helmet } from "react-helmet-async";
import { useLocation } from "wouter";

export function CanonicalTag() {
    const [location] = useLocation();

    // Remove trailing slash unless it's the root path
    const path = location === "/" ? "" : location.replace(/\/$/, "");
    const canonicalUrl = `https://PhotoshopRequest.app${path}`;

    return (
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
        </Helmet>
    );
}
